const decimalNumberRegex = /^\d*\.?\d*$/

export function normalizeDecimalInput(value: string): string | null {
  const sanitized = value.replace(/,/g, '.').replace(/\s/g, '')
  if (sanitized === '') return ''
  if (!decimalNumberRegex.test(sanitized)) return null
  if (sanitized === '.') return '0.'
  if (sanitized.startsWith('.')) return `0${sanitized}`
  if (sanitized.startsWith('0') && !sanitized.startsWith('0.')) {
    const trimmed = sanitized.replace(/^0+(?=\d)/, '')
    return trimmed === '' ? '0' : trimmed
  }
  return sanitized
}

export { decimalNumberRegex }
